import type { ComboboxItemWithValue } from "@replo/design-system/components/combobox/Combobox";

import React from "react";

import {
  ComboboxContent,
  ComboboxItem,
  ComboboxList,
  ComboboxRoot,
  ComboboxTriggerButton,
} from "@replo/design-system/components/combobox/Combobox";
import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";

interface BorderStyleSelectorProps {
  borderStyle: string | null;
  onSelect: (style: string | null) => void;
}

const BORDER_STYLE_OPTIONS = [
  {
    value: "none",
    label: "None",
    displayValue: "None",
  },
  {
    value: "solid",
    label: "Solid",
    displayValue: "Solid",
  },
  {
    value: "dashed",
    label: "Dashed",
    displayValue: "Dashed",
  },
  {
    value: "dotted",
    label: "Dotted",
    displayValue: "Dotted",
  },
  {
    value: "double",
    label: "Double",
    displayValue: "Double",
  },
] as const;

const BorderStyleSelector: React.FC<BorderStyleSelectorProps> = ({
  borderStyle,
  onSelect,
}) => {
  const items: ComboboxItemWithValue[] = BORDER_STYLE_OPTIONS.map((style) => ({
    value: style.value,
    label: style.label,
  }));

  const selectedItem =
    items.find((item) => item.value === (borderStyle ?? "none")) ?? null;

  return (
    <Tooltip
      triggerAsChild={false}
      side="top"
      align="start"
      content="Border Style"
    >
      <div className="border-style-selector flex items-center">
        <ComboboxRoot
          items={items}
          value={selectedItem}
          onValueChange={(item) => {
            onSelect(item?.value ?? null);
          }}
          itemToStringValue={(item) => String(item.label)}
          isItemEqualToValue={(a, b) => a.value === b.value}
          filter={null}
        >
          <ComboboxTriggerButton
            className="w-full"
            isPlaceholder={!borderStyle || borderStyle === "none"}
          >
            {selectedItem?.label ?? "None"}
          </ComboboxTriggerButton>
          <ComboboxContent sideOffset={8} side="bottom" align="center">
            <ComboboxList>
              {(item: ComboboxItemWithValue) => (
                <ComboboxItem key={item.value} {...item} value={item} />
              )}
            </ComboboxList>
          </ComboboxContent>
        </ComboboxRoot>
      </div>
    </Tooltip>
  );
};

export default BorderStyleSelector;
